/* eslint-disable @typescript-eslint/no-explicit-any */
import { lazy, Suspense, memo, type ComponentType } from 'react';
import { Spinner } from '../../ui/_refactor/skeleton/spinner';

const SuspenseFallback = () => {
  return (
    <div className="flex justify-center items-center flex-1 h-screen">
      <Spinner className="h-[40px] w-[40px]" />
    </div>
  );
};

// Memoized wrapper component to prevent unnecessary re-renders
const SuspenseWrapper = memo(({ Component }: { Component: ComponentType }) => (
  <Suspense fallback={<SuspenseFallback />}>
    <Component />
  </Suspense>
));

SuspenseWrapper.displayName = 'SuspenseWrapper';

// Helper to wrap components with Suspense - returns JSX element
// This is safe because React Router handles component lifecycle properly
const withSuspense = (Component: ComponentType) => <SuspenseWrapper Component={Component} />;

// Helper for lazy loading with clean default export handling
const lazyLoad = <T extends ComponentType<any>>(importFn: () => Promise<{ default: T }>) =>
  lazy(importFn) as unknown as T;

export { withSuspense, lazyLoad };
